import { AfterViewChecked, Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';
import { UsersService } from '../shared/services/common/users.service';
import { TabStripComponent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-task-tracker',
  templateUrl: './task-tracker.component.html',
  styleUrls: ['./task-tracker.component.css']
})
export class TaskTrackerComponent implements OnInit, AfterViewChecked {
  initialLoading = false;
  operators: any;
  inputData: { userInfo: any; };
  @ViewChild('trackertabstrip') tabstrip: TabStripComponent;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
  ) { }

  ngOnInit(): void {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.inputData = { userInfo: this.usersService.UserInfo() };
    this.operators = this.authService.getAccessOperatiorsForTab('Task Tracker');
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('#tracker-tab');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '0px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }

}
